import { render, staticRenderFns } from "./DefaultImageButtons.vue?vue&type=template&id=1f5b9ad9&scoped=true"
import script from "./DefaultImageButtons.vue?vue&type=script&lang=ts"
export * from "./DefaultImageButtons.vue?vue&type=script&lang=ts"
import style0 from "./DefaultImageButtons.vue?vue&type=style&index=0&id=1f5b9ad9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5b9ad9",
  null
  
)

/* custom blocks */
import block0 from "./DefaultImageButtons.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports